import type { OrderingProvider } from 'models/Merchant'

// How the post-order email behaves per provider, per nexus
// Orders::SendConfirmationEmail:
// - whole_email (olo/deliverect): #olo_email_enabled? / #deliverect_email_enabled?
//   return false when allow_post_order_feedback_email is off, so the toggle
//   suppresses the whole post-order email.
// - thumbs_prompt_only (toast/square): #order_can_be_emailed? is always true;
//   the toggle only drops the thumbs-up/down prompt. Thanx does not allow
//   merchants to disable rating collection (AI-1197), so the setting is hidden.
// - no_email (qu): absent from #order_can_be_emailed?, so nexus never sends
//   the email and the toggle does nothing; hide it.
// The Record is exhaustive: a new OrderingProvider fails to compile until it
// is classified here.
export type PostOrderEmailBehavior =
  | 'whole_email'
  | 'thumbs_prompt_only'
  | 'no_email'

export const ORDERING_PROVIDER_EMAIL_BEHAVIOR: Record<
  OrderingProvider,
  PostOrderEmailBehavior
> = {
  olo: 'whole_email',
  deliverect: 'whole_email',
  toast: 'thumbs_prompt_only',
  square: 'thumbs_prompt_only',
  qu: 'no_email',
}

export const isWholeEmailProvider = (
  provider?: OrderingProvider | null
): boolean =>
  !!provider && ORDERING_PROVIDER_EMAIL_BEHAVIOR[provider] === 'whole_email'

export const isPostOrderFeedbackHidden = (
  provider?: OrderingProvider | null
): boolean =>
  !!provider && ORDERING_PROVIDER_EMAIL_BEHAVIOR[provider] !== 'whole_email'
